import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { setPopup } from "../../../../actions/parts";
import * as EVENTS from "../../../../constants/config/dtm";
import { GENERIC_TOKEN, PRODUCT_DATASHEET_URL, PRODUCT_URL, PRODUCT_SAMPLE_AND_BUY_URL } from "../../../../constants/config/parts";
import { track } from "../../../../actions/dtm";
import "./style.css";
import { AddMyAnalogModalIcon } from "../../../AddToMyAnalogIcon/AddToMyAnalogIcon";
import { AddToMyCartIcon } from "../../../AddToMyCartIcon/AddToMyCartIcon";
import Datasheets from "../../../Datasheets";

/**
 * @name PartData
 * @function
 * @description Displays Part Data with Documents
 * @returns {JSX}
 * @param {*} props
 */
const PartData = (props) => {
  const dispatch = useDispatch();
  const containerRef = useRef();

  // Function to handle mouse enter event
  const handleMouseEnter = () => {
    dispatch(setPopup(containerRef.current.getBoundingClientRect(), props.id));
  };

  // Function to handle mouse leave event
  const handleMouseLeave = () => {
    dispatch(setPopup());
  }
  

  return (
    <td className={`parts__section ${props.className} ${props.style}`}>
      <div className="parts__container">
        <a
          onClick={() => dispatch(track(EVENTS.PRODUCT_VIEW))}
          href={PRODUCT_URL.replace(GENERIC_TOKEN, props.generic) + ".html"}
          target="_blank"
          rel="noopener noreferrer"
          className="parts__name"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          ref={containerRef}
        >
          {props.displayValue}
        </a>
        
        <div className="parts__tools">
          <AddToMyCartIcon url={PRODUCT_SAMPLE_AND_BUY_URL.replace(GENERIC_TOKEN, props.generic)} />
          <AddMyAnalogModalIcon productID={props.generic} partsData/>
          {props.hasDataSheet && <Datasheets url={PRODUCT_DATASHEET_URL.replace(GENERIC_TOKEN, props.generic)} />}
        </div>
      </div>
    </td>
  );
};

export default PartData;
